export default function Link({ item, location, className, children }) {
  const isExternal = item.url.substr(0, 4) === "http"
  const target = item.target === "_blank" ? item.target : "_self"

  return (
    <a
      className={className}
      href={item.url}
      target={target}
      title={item.label}
      data-type={isExternal ? "external" : "regular"}
      data-menu={location}>
      {item.label}
      {children}
    </a>
  )
}
